
<template>
  <div id="empty"></div>
</template>

<script>
  export default {
    name: 'Empty',
    components: {
    },
    data() {
      return {
      }
    },
    mounted () {
    }

  }
</script>

<style>
</style>
